import { atom } from 'recoil';
import { IAttachment } from '../interfaces/attachment';

export const visitAttachmentsAtom = atom<IAttachment[]>({
  key: 'visitAttachmentsAtom',
  default: [],
});
